import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isRegistered, loading, openRegisterModal } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !isRegistered) {
      openRegisterModal();
      navigate('/', { replace: true });
    }
  }, [isRegistered, loading, openRegisterModal, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0d0f14] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 flex items-center justify-center">
            <i className="ri-loader-4-line animate-spin text-[#00e87a] text-3xl"></i>
          </div>
          <p className="text-[#6b7280] text-sm">Cargando...</p>
        </div>
      </div>
    );
  }

  if (!isRegistered) return null;

  return <>{children}</>;
}
